export default "__VITE_ASSET__c8d222c6__"